/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Dimmer,
  Grid,
  Header,
  Loader,
  Menu,
  Modal,
  Segment,
  Table,
} from 'semantic-ui-react';
import moment from 'moment-timezone';
import { replace } from 'react-router-redux';
import { isEqual } from 'lodash';
import qs from 'qs';
import { withTranslation } from 'react-i18next';
import OfflinePaymentItem from './OfflinePaymentItem';
import AttachmentModal from '../BookingPayment/AttachmentModal';


import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import { serverRequestGet, serverRequestPut } from '../../actions/fetchM';

import PageNav from '../../components/PageNav';
import SearchFilter from '../../components/SearchFilter';
import SortButton from '../../components/SortButton';
import config from '../../../config';

import isNumber from '../../utils/numbers/isNumber';
import { decodeSearch, encodeSearch } from '../../utils/url';

import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

const FILTERS = [
  { value: 'all', text: 'All', isShow: true },
  { value: 'bank_transfer', text: 'Bank Transfer', isShow: true },
  { value: 'virtual_account', text: 'Virtual Account', isShow: true },
  { value: 'cheque', text: 'Cheque', isShow: true },
  { value: 'cash', text: 'Cash', isShow: true },
  { value: 'credit_card', text: 'Credit Card', isShow: true },
  { value: 'others', text: 'Others', isShow: true },
];
class OfflinePayments extends Component {
  static contextTypes = {
    store: PropTypes.object,
    router: PropTypes.object,
  }
  static propTypes = {
    auth: PropTypes.shape({
      company: PropTypes.object,
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
    }),
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const filters = FILTERS.filter(e => e.isShow);
    const currentFilter = filters.some(t => t.value === query.filter) ? query.filter : filters[0].value;
    const currentPageNum = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    const windowWidth = window.innerWidth;
    const isTablet = windowWidth >= 768 && windowWidth < 992;
    return {
      currentFilter,
      currentPageNum,
      filters,
      search,
      isTablet,
    };
  }
  constructor(props) {
    super(props);
    const state = OfflinePayments.getPropsToState(props);
    this.state = {
      count: 0,
      data: [],
      genericErrMsg: 'An error occurred, please refresh page',
      limit: 10,
      loading: true,
      modal: {
        isOpen: false,
        type: '',
        bookingData: {},
        paymentID: '',
      },
      attachmentModalState: false,
      attachmentModalData: {},
      offset: 0,
      token: '',
      ...state,
    };
  }
  componentDidMount() {
    const { currentFilter, filters } = this.state;
    const oriQuery = decodeSearch(this.props.location.search);
    const query = decodeSearch(this.props.location.search);
    if (!isNumber(query.page) || query.page <= 0) {
      delete query.page;
    }
    if (!query.filter) {
      query.filter = currentFilter;
    } else if (query.filter && !filters.some(t => t.value === query.filters)) {
      query.filter = currentFilter;
    }
    if (!isEqual(oriQuery, query)) this.replaceQuery(query);
    this.fetchBookingFeePayments(query);
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = OfflinePayments.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, res);
    });
  }
  approvePayment = async (e, paymentID) => {
    e.preventDefault();
    const modal = {
      isOpen: false,
      type: '',
      bookingData: {},
      paymentID: '',
    };
    await this.setComponentState({ modal });
    const data = {
      approvedName: this.props.auth.preferredName,
      approvedUserID: this.props.auth.id,
      approvedAt: moment().toDate(),
      status: 'paid',
    };
    await this.updateBookingFeePayment(data, paymentID);
  }
  rejectPayment = async (e, paymentID) => {
    e.preventDefault();
    const modal = {
      isOpen: false,
      type: '',
      bookingData: {},
      paymentID: '',
    };
    await this.setComponentState({ modal });
    const data = {
      rejectedName: this.props.auth.preferredName,
      rejectedUserID: this.props.auth.id,
      rejectedAt: moment().toDate(),
      status: 'rejected',
    };
    await this.updateBookingFeePayment(data, paymentID);
  }
  replaceQuery(query, resetPage = false) {
    const { store, router } = this.context;
    const { pathname } = router.location;
    const newQueryParams = Object.assign({}, query);
    if (resetPage) {
      newQueryParams.page = 1;
    }
    store.dispatch(replace(`${pathname}?${encodeSearch(newQueryParams)}`));
    this.fetchBookingFeePayments(newQueryParams);
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  getCountDisplay = (count, currentPageNum, limit, offset) => {
    const fromCount = offset || 1;
    let toCount = currentPageNum * (limit);
    const totalCount = count || 0;
    if (totalCount < toCount) toCount = totalCount;

    return `${fromCount}-${toCount} of ${totalCount}`;
  }
  async fetchBookingFeePayments(q) {
    const { store } = this.context;
    const { genericErrMsg } = this.state;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    if (query.filter === 'all') delete query.filter;
    let queryString = '';
    if (qs.stringify(query)) {
      queryString = `?${qs.stringify(query)}`;
    }
    await this.setLoading(true);
    try {
      const response = await serverRequestGet(
        `/manage/booking_fee_payments/${queryString}`,
        store,
      );
      const { count, data, limit, offset, token } = response;
      await this.setLoading(false);
      this.setState({
        count, data, limit, offset, token,
      });
    } catch (e) {
      this.handleError(store, genericErrMsg, e, true);
    }
  }
  async handleError(store, msg, errorObj, isBugsnag = false) {
    await this.setLoading(false);
    await store.dispatch(flashErrorMessage({ message: msg }));
    if (isBugsnag) Bugsnag.notifyException(errorObj);
  }
  handleChangeFilter = (e, { name }) => {
    const currentFilter = name;
    const query = decodeSearch(this.props.location.search);
    this.setState({
      currentFilter,
      data: [],
      offset: 0,
      count: 0,
      limit: 3,
      currentPageNum: 1,
    }, () => {
      this.replaceQuery({
        filter: currentFilter,
        search: query.search || null,
      }, true);
    });
  }
  handleChangePage = (currentPageNum) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPageNum;
    this.setState({
      currentPageNum,
    });
    this.replaceQuery(query);
  }
  handleResize = () => {
    const windowWidth = window.innerWidth;
    const isTablet = windowWidth >= 768 && windowWidth < 992;
    if (isTablet !== this.state.isTablet) {
      this.setState({ isTablet });
    }
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query, true);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    this.setState({
      search: '',
    }, () => {
      if (hasQuery) {
        this.replaceQuery(query, true);
      }
    });
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  handleModalOnClose = (e) => {
    e.preventDefault();
    const modal = {
      isOpen: false,
      type: '',
      bookingData: {},
      paymentID: '',
    };
    this.setState({ modal });
  }
  handleModalOpen = (e, type, paymentID, bookingData) => {
    e.preventDefault();
    const modal = {
      isOpen: true,
      type,
      bookingData,
      paymentID,
    };
    this.setState({ modal });
  }
  handleOpenAttachment = (e, data) => {
    e.preventDefault();
    const d = {};
    d.paymentPictures = data.paymentPictures;
    d.bookingID = data.bookingID;
    this.setState({
      attachmentModalState: true,
      attachmentModalData: d,
    });
  }
  handleCloseAttachment = () => {
    this.setState({
      attachmentModalState: false,
    });
  }
  updateBookingFeePayment = async (dataToUpdate = {}, paymentID) => {
    const { data, genericErrMsg, token } = this.state;
    const { store } = this.context;
    try {
      await this.setLoading(true);
      const response = await serverRequestPut(
        `/manage/booking_fee_payments/${paymentID}/`,
        store,
        token,
        dataToUpdate,
      );
      await this.setLoading(false);
      if (response.error) {
        await store.dispatch(flashErrorMessage({ message: response.message }));
        return;
      }
      const i = data.findIndex(val => (val.id === paymentID));
      if (i === -1) {
        this.handleError(store, genericErrMsg);
        return;
      }
      data[i] = Object.assign(data[i], dataToUpdate);
      this.setState({ data });

      await store.dispatch(flashSuccessMessage({ message: 'Payment updated.' }));
    } catch (e) {
      this.handleError(store, genericErrMsg, e, true);
    }
  }
  getExportURL = (type) => {
    const query = Object.assign({}, decodeSearch(this.props.location.search));
    query.fileType = type;
    if (query.filter === 'all') delete query.filter;
    return `${config.get('bookApiURL')}/manage/booking_fee_payments/export/?${qs.stringify(query)}`;
  }
  render() {
    const { t } = this.props;
    const {
      count = 0,
      currentFilter,
      currentPageNum,
      filters,
      limit = 10,
      loading,
      modal,
      attachmentModalData,
      attachmentModalState,
      offset = 1,
      search,
      isTablet,
    } = this.state;
    let {
      data = [],
    } = this.state;
    if (!data) data = [];
    const isVATab = currentFilter === 'virtual_account';
    const exportItems = [
      {
        text: 'CSV',
        href: this.getExportURL('csv'),
        icon: 'download',
      },
      {
        text: 'Excel',
        href: this.getExportURL('excel'),
        icon: 'download',
      },
    ];
    const sortItems = [
      {
        text: 'Latest Payment',
        icon: 'sort alphabet ascending',
        sortColumn: 'booking_fee_payment.created_at',
        sortDirection: 'desc',
      },
      {
        text: 'Oldest Payment',
        icon: 'sort alphabet descending',
        sortColumn: 'booking_fee_payment.created_at',
        sortDirection: 'asc',
      },
      {
        text: 'Customer Name Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'booking__customer__customer_detail.name',
        sortDirection: 'asc',
      },
      {
        text: 'Customer Name Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'booking__customer__customer_detail.name',
        sortDirection: 'desc',
      },
    ];
    return (
      <Container>
        <Modal
          basic
          open={modal.isOpen}
          onClose={this.handleModalOnClose}
        >
          <Header icon={modal.type === 'approve' ? 'check' : 'x'} content={modal.type === 'approve' ? t('Approve Payment') : t('Reject Payment')} />
          <Modal.Content>
            <Modal.Description>
              {modal.type === 'approve' &&
                <p>
                  {t('Confirm Approve payment for')}&nbsp;
                  {modal.bookingData.projectUnit.reference}, <br className="large-hide" />{modal.bookingData.project.name}, <small>{modal.bookingData.code}</small>
                  ?</p>
              }
              {modal.type === 'reject' &&
                <p>
                  <p>
                    {t('Confirm Reject payment for')}&nbsp;
                    {modal.bookingData.projectUnit.reference}, <br className="large-hide" />{modal.bookingData.project.name}, <small>{modal.bookingData.code}</small>
                    ?</p>
                </p>
              }
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.handleModalOnClose} icon="cancel" content="No" />
            <Button
              positive={modal.type === 'approve'}
              negative={modal.type === 'reject'}
              onClick={(e) => {
                if (modal.type === 'approve') {
                  this.approvePayment(e, modal.paymentID);
                }
                if (modal.type === 'reject') {
                  this.rejectPayment(e, modal.paymentID);
                }
              }}
              icon="checkmark"
              content={modal.type === 'approve' ? t('Approve') : t('Reject')}
            />
          </Modal.Actions>
        </Modal>
        <AttachmentModal
          modalState={attachmentModalState}
          data={attachmentModalData}
          onClose={this.handleCloseAttachment}
        />
        <Grid verticalAlign="middle">
          <Grid.Row>
            <Grid.Column >
              <Menu
                stackable
                secondary
                color="blue"
              >
                {
                  filters.map((filter, key) => (
                    <Menu.Item
                      key={key}
                      name={filter.value}
                      onClick={this.handleChangeFilter}
                      active={currentFilter === filter.value}
                      style={{ margin: '0 2px' }}
                    >{(t(filter.text)).toUpperCase()}</Menu.Item>
                  ))
                }
              </Menu>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <SearchFilter
                isLoading={loading}
                onChange={this.handleFilterOnChange}
                onClose={this.handleClearFilter}
                search={search}
                placeholder={t('Search Purchaser, Project Name, IC')}
                leftNav={(
                  <PageNav
                    currentPage={currentPageNum}
                    count={count || 0}
                    limit={limit || 10}
                    offset={offset || 0}
                    dataSize={data.length || 0}
                    loading={loading}
                    onChange={this.handleChangePage}
                  />
                )}
                rightNav={
                  count > 0 && !loading ? (
                    <Grid.Row style={isVATab ? { marginTop: '-2.2em' } : null}>
                      <Header as="h4" textAlign="right">
                        {this.getCountDisplay(count, currentPageNum, limit, offset)}
                      </Header>
                      { isVATab && (
                        <Grid.Column textAlign="right">
                          <SortButton
                            floated="right"
                            loading={loading}
                            items={sortItems}
                            onSort={this.handleSortData}
                          />
                          <SortButton
                            floated="right"
                            icon="download"
                            loading={loading}
                            items={exportItems}
                          />
                        </Grid.Column>
                      )}
                    </Grid.Row>
                  ) : <span />
                }
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="app--listdata">
            <Grid.Column>
              <Dimmer style={{ zIndex: 20 }} active={loading} inverted>
                <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              {
              data && data.length > 0 ? (
                <Grid columns={2} className="equal height">
                  <Grid.Row>
                    <Grid.Column width={16}>
                      <Table celled collapsing>
                        <Table.Header className="mobile-hide">
                          <Table.Row>
                            <Table.HeaderCell>{t('Booking')}</Table.HeaderCell>
                            <Table.HeaderCell>{t('Purchaser')}</Table.HeaderCell>
                            <Table.HeaderCell>{t('Amount')}</Table.HeaderCell>
                            {/* <Table.HeaderCell textAlign="right">Requester</Table.HeaderCell> */}
                            { isVATab &&
                              <Table.HeaderCell textAlign="right">{t('Virtual Account')}</Table.HeaderCell>
                            }
                            <Table.HeaderCell textAlign="right">{t('Status')}</Table.HeaderCell>
                            <Table.HeaderCell textAlign="center">{t('Manage')}</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          {
                            data.map((item, index) => (
                              <OfflinePaymentItem
                                key={index}
                                auth={this.props.auth}
                                item={item}
                                approvePayment={this.approvePayment}
                                rejectPayment={this.rejectPayment}
                                handleModalOpen={this.handleModalOpen}
                                handleOpenAttachment={this.handleOpenAttachment}
                                currentFilter={currentFilter}
                                isTablet={isTablet}
                              />
                            ))
                          }
                        </Table.Body>
                      </Table>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              ) : (
                <Segment textAlign="center">
                  <p>{t('No payments found')}.</p>
                </Segment>
              )
            }
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation([
  ...namespaces,
])(OfflinePayments);



// WEBPACK FOOTER //
// ./src/containers/Payments/OfflinePayments.jsx